import React from "react";

export default function renderIcon({
  width = 16,
  height = 16,
  color = "#4B1E78",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 3 V8 H3" />
      <path d="M16 3 V8 H21" />
      <path d="M8 21 V16 H3" />
      <path d="M16 21 V16 H21" />
    </svg>
  );
}
